import React, { FC } from 'react'

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

import { SlideMenuOpenCloseButton } from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenuItems/SlideMenuStateButton/styled'

export interface SlideMenuStateButtonProps {
	readonly isOpen?: boolean
}

const SlideMenuStateButton: FC<SlideMenuStateButtonProps> = ({
	isOpen,
}: SlideMenuStateButtonProps) => {
	return (
		<SlideMenuOpenCloseButton disableRipple isOpen={isOpen}>
			<ArrowBackIosIcon fontSize={'small'} color={'primary'} />
		</SlideMenuOpenCloseButton>
	)
}

export default SlideMenuStateButton
